export default __webpack_public_path__ + "static/media/contact1.77bbf215.jpg";